import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { FeatherIconModule } from './feather/feather.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxbootstrapModule } from 'src/app/shared/ngx-bootstrap/ngxbootstrap.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LightgalleryModule } from 'lightgallery/angular';
import { CountUpModule } from 'ngx-countup';
import { TimepickerActions, TimepickerModule } from 'ngx-bootstrap/timepicker';
import {DatePipe, NgClass} from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { Tool } from 'angular-feather/icons';
import {CustomPaginationModule} from "./custom-pagination/custom-pagination.module";
import {StatusComponent} from "./status/status.component";

const icons = {
  Tool
};
@NgModule({
  declarations:[
    StatusComponent
  ],
  imports: [
    FeatherIconModule,
    MaterialModule,
    FormsModule,
    DragDropModule,
    NgxbootstrapModule,
    PopoverModule,
    MatTooltipModule,
    BsDatepickerModule.forRoot(),
    NgxDropzoneModule,
    MatStepperModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    LightgalleryModule,
    CountUpModule,
    TimepickerModule,
    FeatherModule.pick(icons),
    CustomPaginationModule,
    NgClass,
  ],
  exports: [
    MaterialModule,
    FeatherIconModule,
    FormsModule,
    DragDropModule,
    NgxbootstrapModule,
    PopoverModule,
    MatTooltipModule,
    BsDatepickerModule,
    NgxDropzoneModule,
    MatStepperModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    LightgalleryModule,
    CountUpModule,
    TimepickerModule,
    FeatherModule,
    CustomPaginationModule,
    StatusComponent,
  ],
  providers: [
    DatePipe,
    TimepickerActions,
    BsDatepickerConfig,
  ],
})
export class sharedModule {}
